import React from 'react';
import i18next from 'i18next';
import PendingButton from '../Button/PendingButton';
import Api from '../../api';
import InputText from '../InputText/InputText';
import apiForm from './apiForm';
import FormErrors from './FormErrors';
import Icon from '../Icon/Icon';
import logo from 'icons/logo-small.svg';
import makeCancelable from '../../api/cancelable';
import Checkbox from './Checkbox/Checkbox';

class SignUpForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.requests = [];
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  onSubmit = (e) => {
    const { promise, cancel } = makeCancelable(
      Api.signUp(this.props.serializeForm(e.currentTarget))
    );
    this.requests.push(cancel);

    e.preventDefault();
    this.props.beforeSubmit();
    promise.then((response) => {
      if (response.status === 'success') {
        window.location.reload();
      } else {
        this.props.afterSubmit(response);
      }
    });
  };

  render() {
    const {
      formState: { pending, errors, invalid },
    } = this.props;

    return (
      <div className="form form--modal sign-up-form">
        <form onSubmit={this.onSubmit}>
          <Icon glyph={logo} className="form__logo" />
          <span className="form__title form__title--center">
            {i18next.t('sign_up.title')}
          </span>

          <InputText
            name="username"
            placeholder={i18next.t('sign_up.login')}
            className={
              'form__input' + (invalid.includes('username') ? ' invalid' : '')
            }
          />
          <InputText
            name="email"
            placeholder="e-mail"
            className={
              'form__input' + (invalid.includes('email') ? ' invalid' : '')
            }
          />
          <InputText
            type="password"
            name="password"
            placeholder={i18next.t('sign_up.pass')}
            className={
              'form__input' + (invalid.includes('password') ? ' invalid' : '')
            }
          />
          <InputText
            type="password"
            name="passwordConfirm"
            placeholder={i18next.t('sign_up.pass_confirm')}
            className={
              'form__input' +
              (invalid.includes('passwordConfirm') ? ' invalid' : '')
            }
          />

          <div className="form__field sign-up-form__policy">
            <Checkbox name="policy">
              {i18next.t('sign_up.agree1')}
              <a href="/#/terms" target="_blank" className="link">
                {i18next.t('sign_up.agree2')}
              </a>
            </Checkbox>
          </div>

          <FormErrors errors={errors} />

          <div className="form__spacer" />

          <PendingButton
            tagName="button"
            className="form__submit"
            pending={pending}
          >
            {i18next.t('sign_up.action')}
          </PendingButton>
        </form>
      </div>
    );
  }
}

export default apiForm(SignUpForm);



// WEBPACK FOOTER //
// ./app/components/Form/SignUpForm.jsx